export default "__VITE_ASSET__DWguEkKU__"